import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useFamilyStore } from '@/hooks/useStores';
import MemoryCard from '@/components/person/MemoryCard';
import type { StoryType } from '@/stores/models/Story';

import './family-memory-card.css';

interface FamilyMemoryCardProps {
  story: StoryType;
  familyId: string;
  canEdit?: boolean;
  canDelete?: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
  compact?: boolean;
}

const FamilyMemoryCard: React.FC<FamilyMemoryCardProps> = ({
  story,
  familyId,
  canEdit,
  canDelete,
  onEdit,
  onDelete,
  compact = false
}) => {
  const familyStore = useFamilyStore();
  const navigate = useNavigate();

  const memberId = story.familyMemberId;
  const person = memberId ? familyStore.getPerson(memberId) : undefined;
  const memberName = person?.fullName || (person ? `${person.firstName} ${person.lastName}`.trim() : undefined);

  if (compact) {
    return (
      <button
        type="button"
        className="family-memory-card family-memory-card--compact"
        onClick={() => navigate(`/families/${familyId}/memories/${story.id}`)}
      >
        <span className="family-memory-card__compact-title">{story.title}</span>
        <span className="family-memory-card__compact-meta">{memberName || 'Member'}</span>
      </button>
    );
  }

  return (
    <MemoryCard
      story={story}
      familyId={familyId}
      showMemberChip
      memberName={memberName || 'Member'}
      canEdit={canEdit}
      canDelete={canDelete}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  );
};

export default FamilyMemoryCard;
